

import {Component, EventEmitter, Input, OnInit, Output, ViewContainerRef} from '@angular/core';
import {ApiAdminMajorIncidentTaskService} from "../../../../../../services/api/admin/admin-major-incident-tasks/admin-major-incident-tasks.service";
import {Dialog} from "../../../../../../shared/dialog/dialog";

@Component({
  selector: 'app-admin-major-incident-tasks-create-edit-dialog',
  templateUrl: './admin-major-incident-tasks-create-edit-dialog.component.html'
})

export class AdminMajorIncidentTasksComponentDialog implements Dialog {

  @Input() data; // {id: 122, requestTypeId: 12}
  @Output() remove = new EventEmitter<any>();

  isLoading = true;
  loadedId = null;

  requestTypeId;

  loadedData;

  constructor(
    private apiAdminMajorIncidentTaskService: ApiAdminMajorIncidentTaskService
  ) {}


  ngOnInit(): void {
    this.requestTypeId = this.data.requestTypeId;

    if(this.data.id !== null){
      this.loadedId = this.data.id;
      this.getData();
      this.getData();
    } else {

      // Load Default Data
      this.loadedData = {
        TaskName: '',
        IsCommunicationTask: 0,
        SmsTemplateText: '',
        EmailTemplateText: '',
      }

      this.isLoading = false;

    }
  }

  getData(){
    this.isLoading = true;
    this.apiAdminMajorIncidentTaskService.get(this.requestTypeId, this.loadedId).then(response => {
      this.loadedData = response;
      this.isLoading = false;
    })
  }

  close(){
    this.remove.emit(null);
  }

  save(){
    if(this.loadedId){
      this.apiAdminMajorIncidentTaskService.update(this.requestTypeId, this.loadedId, this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    } else {
      this.apiAdminMajorIncidentTaskService.create(this.requestTypeId, this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    }

  }
}
